// extracted by mini-css-extract-plugin
export var header = "_w8-1";
export var maskBottom = "_w8-6";
export var maskMiddle = "_w8-7";
export var maskTop = "_w8-5";
export var root = "_w8-0";
export var scrollDownButton = "_w8-3";
export var scrollDownButtonHidden = "_w8-4";
export var viewport = "_w8-2";